// extracted by mini-css-extract-plugin
module.exports =  {"tc-tile-container":"Tile-module__tc-tile-container___m45JT","tc-tile-body":"Tile-module__tc-tile-body___Wn2PY","tc-tile-footer":"Tile-module__tc-tile-footer___CV9oF"};